import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row bg-cyan-8 text-white q-pa-sm" }
const _hoisted_2 = { class: "col-lg-7 col-xs-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row adicon-font-1" }
const _hoisted_5 = { class: "col-lg-7 col-sm-12 col-xs-12" }
const _hoisted_6 = { class: "row q-pa-md" }
const _hoisted_7 = { class: "col-lg-1 col-md-1 col-sm-1 col-xs-2" }
const _hoisted_8 = { class: "col-lg-11 col-md-11 col-sm-11 column flex-center desktop-only" }
const _hoisted_9 = {
  key: 0,
  class: "adicon-navbar full-width",
  style: {"text-align":"right"}
}
const _hoisted_10 = { href: "#inicio" }
const _hoisted_11 = { href: "#servicios" }
const _hoisted_12 = { href: "#nuestra-mision" }
const _hoisted_13 = { href: "#clientes" }
const _hoisted_14 = { href: "#contacto" }
const _hoisted_15 = {
  key: 1,
  class: "adicon-navbar full-width",
  style: {"text-align":"right"}
}
const _hoisted_16 = {
  key: 0,
  class: "col-xs-1 column flex-center mobile-only"
}
const _hoisted_17 = {
  key: 1,
  class: "col-xs-1 column flex-center mobile-only"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md" }
const _hoisted_20 = { class: "row" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mobileNavDrawer = ref(false);

const openExternalLink = (url: string) => {
  window.open(url, "_blank");
};

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh Lpr lFf" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_space),
            _createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              dense: "",
              icon: "fab fa-facebook",
              color: "primary",
              class: "text-white on-left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openExternalLink('https://www.facebook.com/AMRAdvisors/')))
            }),
            _createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              dense: "",
              icon: "fab fa-linkedin",
              color: "primary",
              class: "text-white on-left",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
              openExternalLink('https://www.linkedin.com/company/amr-advisors/')
            ))
            }),
            _createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              dense: "",
              icon: "fab fa-twitter",
              color: "primary",
              class: "text-white on-left",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openExternalLink('https://twitter.com/AMRAdvisors')))
            }),
            _createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              dense: "",
              icon: "fab fa-instagram",
              color: "primary",
              class: "text-white on-left",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openExternalLink('https://www.instagram.com/amradvisors')))
            })
          ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_img, {
                src: require('@/assets/logo.svg')
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.$route.fullPath == '/' || _ctx.$route.fullPath.includes('/#'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                    _createElementVNode("li", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, _cache[21] || (_cache[21] = [
                        _createTextVNode("Inicio")
                      ]))), [
                        [_directive_smooth_scroll]
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, _cache[22] || (_cache[22] = [
                        _createTextVNode("Servicios")
                      ]))), [
                        [_directive_smooth_scroll]
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, _cache[23] || (_cache[23] = [
                        _createTextVNode("Nosotros")
                      ]))), [
                        [_directive_smooth_scroll]
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, _cache[24] || (_cache[24] = [
                        _createTextVNode("Nuestros clientes")
                      ]))), [
                        [_directive_smooth_scroll]
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, _cache[25] || (_cache[25] = [
                        _createTextVNode("Contacto")
                      ]))), [
                        [_directive_smooth_scroll]
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/vacancies" }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("Vacantes")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createElementVNode("i", { class: "fas fa-arrow-left on-left" }, null, -1),
                        _createTextVNode("Volver al inicio")
                      ])),
                      _: 1
                    })
                  ]))
            ]),
            _createVNode(_component_q_space),
            (_ctx.$route.fullPath == '/' || _ctx.$route.fullPath.includes('/#'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    dense: "",
                    class: "text-primary",
                    icon: "fas fa-bars",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileNavDrawer.value = true))
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    dense: "",
                    class: "text-primary",
                    icon: "fas fa-home",
                    to: "/"
                  })
                ]))
          ])
        ]),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col" }, null, -1))
      ]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createVNode(_component_q_page_sticky, {
            position: "bottom-right",
            offset: [18, 18]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                fab: "",
                icon: "fab fa-whatsapp",
                color: "deep-orange-7",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (openExternalLink('https://wa.me/50763672239')))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_dialog, {
        modelValue: mobileNavDrawer.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((mobileNavDrawer).value = $event)),
        persistent: "",
        maximized: "",
        "transition-show": "slide-left",
        "transition-hide": "slide-right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, {
            dark: "",
            class: "bg-primary text-white adicon-drawer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      icon: "fas fa-times",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (mobileNavDrawer.value = false))
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "#inicio",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Inicio"),
                  _createElementVNode("a", {
                    href: "#servicios",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Servicios"),
                  _createElementVNode("a", {
                    href: "#nuestra-mision",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Nosotros"),
                  _createElementVNode("a", {
                    href: "#clientes",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Nuestros clientes"),
                  _createElementVNode("a", {
                    href: "#directors",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Nuestra dirección"),
                  _createElementVNode("a", {
                    href: "#contacto",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (mobileNavDrawer.value = false)),
                    class: "adicon-drawer-link adicon-font-1 text-bold q-mb-md"
                  }, "Contacto"),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: "/vacancies",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (mobileNavDrawer.value = false))
                    }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode("Vacantes")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      flat: "",
                      dense: "",
                      icon: "fab fa-facebook",
                      color: "primary",
                      class: "text-white on-left",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (openExternalLink('https://www.facebook.com/AMRAdvisors/')))
                    }),
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      flat: "",
                      dense: "",
                      icon: "fab fa-linkedin",
                      color: "primary",
                      class: "text-white on-left",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (
                openExternalLink(
                  'https://www.linkedin.com/company/amr-advisors/'
                )
              ))
                    }),
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      flat: "",
                      dense: "",
                      icon: "fab fa-twitter",
                      color: "primary",
                      class: "text-white on-left",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (openExternalLink('https://twitter.com/AMRAdvisors')))
                    }),
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      flat: "",
                      dense: "",
                      icon: "fab fa-instagram",
                      color: "primary",
                      class: "text-white on-left",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (openExternalLink('https://www.instagram.com/amradvisors')))
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})